import type { DocMigration } from "../docMigration";
import { migrateModelFromStaticRoomLayoutToDoc } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_68: DocMigration = {
  maxSchemaVersion: "0.0.68",
  description: "Refactor annotation to extend DocEntityBase and be on top-level document",
  apply(json: any) {
    migrateModelFromStaticRoomLayoutToDoc(json, "annotation", "ANNOTATION");
    return json;
  },
};

export default migration_0_0_68;
